// extracted by mini-css-extract-plugin
export default {"button":"profile-edit_button__QN08M"};